var _defs, _line, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockContact01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.3 17.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#113865;}.cls-3{fill:#113865;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    className: "cls-1",
    x1: 2.15,
    y1: 4.46,
    x2: 14.15,
    y2: 13.46
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_285",
    "data-name": "Path 285"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.65,1a8,8,0,1,1-8,8A8,8,0,0,1,8.65,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.65,2a7,7,0,1,0,7,7,7,7,0,0,0-7-7m0-1a8,8,0,1,1-8,8A8,8,0,0,1,8.65,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockContact01);
export default __webpack_public_path__ + "static/media/Block Contact-01.ad4f839a0b452752f9432f1941f8f2b2.svg";
export { ForwardRef as ReactComponent };